import { memo, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./FaqArticle.scss";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import AppGlobalsContext from "app/AppGlobalsContext";
import { prefixInternalRichTextLinks } from "app/utils/utils.url";

const FaqArticle = ({ title, content = [] }) => {
	const { track } = useAnalytics();
	const { envVars } = useContext(AppGlobalsContext);
	const micrositePrefix = envVars?.PROXY_BASENAME_PREFIX;
	const transformHtml = html => prefixInternalRichTextLinks(html, micrositePrefix);

	useEffect(() => {
		if (title) {
			track("faq_article_page", { name: String(title) });
		}
	}, [title]);

	return (
		<div className="faq-article">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				variantMD={TYPOGRAPHY_VARIANTS.XL5}
				isBold
				className="faq-article__title"
			>
				{title}
			</Typography>
			<Paragraphs
				enableHTMLFormatting={true}
				paragraphs={content}
				transformHtml={transformHtml}
			/>
		</div>
	);
};

FaqArticle.propTypes = {
	title: PropTypes.string,
	content: PropTypes.array,
};

export default memo(FaqArticle);
